export default __webpack_public_path__ + "static/media/ILUSTRACIONES_07.210f6a94.png";